export class ImageAppFilterModel {
    skip: number
    take: number
    search: string
  }